/** @module Apparel/CopyColorMaterial **/
define([
	"dojo/_base/declare",
	"csi/table/Copy",
	"csi/xml"
], function(declare,Copy,xml) {

	var PROPAGATE = "Propagate3DMaterial";
	var PROPAGATE_FIELD = "3DPropagate3DMaterials";
	var COLOR_SPECIFICATION = "ColorSpecification";
	const PRODUCT_SOURCE = "ProductSource";
	const PRODUCT_SOURCES = "ProductSources";


	return declare(Copy, {
		/**
		 * Call server Java operation to copy Color Material and propagate 3D Material if needed
		 */
		toWriterRequest: function() {
			var formData = this.getFormData();
			const productSourceFieldValue = this.getParent().ColorAllocationStatus === "ColorAllocationStatus:Allocation WIP" ? formData.getFieldValue(PRODUCT_SOURCE, true) : null;
			// Copy Color Material using server operation
			var call = this.inherited(arguments)
				.addParameter(PROPAGATE, xml.ATTR_BOOLEAN, formData.getFieldValue(PROPAGATE_FIELD, true))
				.addParameter(COLOR_SPECIFICATION, xml.ATTR_REF, formData.getFieldValue(COLOR_SPECIFICATION, true))
				.addParameter(PRODUCT_SOURCES, xml.ATTR_REFLIST, productSourceFieldValue);

			// ParentURL needs to be fixed when copying from the site level color material table
			if (this.m_urlParent == "centric://APPAREL/Views") {
				call.addParameter(xml.PROP_URL_PARENT, xml.ATTR_REF, this.urlOwnerParent);
			}

			return call;
		}
	});
});